
import { Typography, Card, CardContent,Tooltip, Stack, Divider } from '@mui/material';

import IconButton from '@mui/material/IconButton';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
// ----------------------------------------------------------------------

const feedback = [
    {
        data: '10-02-2022',
        esforco: 8,
        dor: 7,
        comentario: 'Doi muito na coluna.....  Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, when'
    },
    {
        data: '05-01-2022',
        esforco: 3,
        dor: 3,
        comentario: 'adorei!  Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, when'
    },
    {
        data: '01-01-2022',
        esforco: 5,
        dor: 6,
        comentario: 'Lorem Ipsum is simply dummy text of the print1500s, when a Ipsum is simply dummy text of the print1500s, when Ipsum is simply dummy text of the print1500s, whenn unknown printer took a galley of type and scrambled it to make a type specm Ipsu'
    },
]


export default function Comentarios() {
  

  return (
    
    <Typography variant="h6">Comentários

        {feedback.map((feedback) => (
            <Card sx={{margin: 2}} key={feedback.data}>
                <CardContent>
                    <Stack direction = "row" alignItems="center" spacing={0.5} sx={{paddingTop: 2}}>
                        <Typography variant="body1" sx={{paddingRight:2}}><b>{feedback.data}</b></Typography>
                        <Divider orientation="vertical" flexItem />

                        <Typography variant="body2"  sx={{paddingRight:2, paddingLeft:2}}>Dor: {feedback.dor}/10</Typography>
                        <Divider orientation="vertical" flexItem />
                        
                        <Typography variant="body2" sx={{paddingRight:2, paddingLeft:2}}>Esforço: {feedback.esforco}/10</Typography>
                        <Divider orientation="vertical" flexItem />

                        <Tooltip title="Ouvir">
                            <IconButton aria-label="audio" sx={{paddingRight:2, paddingLeft:2}} size="small">
                                <PlayCircleFilledWhiteIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                    <Typography variant="body2">{feedback.comentario}</Typography>
                </CardContent>
            </Card>
        ))}
    </Typography>

  );
}
